import React from "react";
import BrandWordmark from "@/components/ui/BrandWordmark";

const Logo = () => {
  return (
    <div className="font-jakarta">
      <BrandWordmark variant="compact" />
    </div>
  );
};

export default Logo;
